import React from "react";

export function arraysEqual(a: number[],b: number[]) {
    if (a.length !== b.length)
        return false;
    for(let i=0; i< a.length; i++) {
        if (a[i] !== b[i]) {
            return false;
        }
    }
    return true;
}

export const useOutsideClick = (callback: () => void) => {
    const ref = React.useRef<any>();

    React.useEffect(() => {
        const handleClick = (event: any) => {
            if (ref.current && !ref.current.contains(event.target)) {
                callback();
            }
        };

        document.addEventListener('click', handleClick, true);

        return () => {
            document.removeEventListener('click', handleClick, true);
        };
    }, [ref]);

    return ref;
};
